module.exports = __webpack_public_path__ + "img/module-28-bg.e062c034.webp";